
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class extends Vue {
  get autoBindings () {
    return {
      // Use none as a hack to prevent chrome autofill
      autocomplete: 'none',
      autocorrect: 'off',
      autocapitalize: 'off',
      spellcheck: 'false'
    }
  }
}
